import {
  FETCH_WATER_AUTHORITIES_FAILURE,
  FETCH_WATER_AUTHORITIES_REQUEST,
  FETCH_WATER_AUTHORITIES_SUCCESS,
} from "../actions/waterAuthorities.actions";

const initialState = {
  data: [],
  loading: false,
};

const waterAuthorities = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WATER_AUTHORITIES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_WATER_AUTHORITIES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case FETCH_WATER_AUTHORITIES_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default waterAuthorities;
